var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card dashboard-panel-activity-stream" }, [
    _c("div", { staticClass: "card-header" }, [
      _vm._v("\n        Activity stream\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body pt-0" },
      _vm._l(_setup.items, function (item) {
        return _c(_setup.DashboardActivityStreamItem, {
          key: item.id,
          attrs: {
            "get-user-id": _setup.getUserId,
            item: item,
            "set-user-id": _setup.setUserId,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }